import script from "./ParticipantCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantCard.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantCard.vue?vue&type=style&index=0&id=62a32186&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a32186"]])

export default __exports__